/* eslint-disable no-underscore-dangle */
import React, { useRef } from 'react';
import TableContainer from '@material-ui/core/TableContainer';
import MatTable from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import { WithStyles } from '@material-ui/styles';
import { Link } from 'react-router-dom';
import TableHead from './TableHead';
import { formatDate } from '../../../utils/date';
import { convertDateWithTimezone, convertDateToTimeWithTimezone } from '../../../utils/helpers';
import styles from './SmartInventoryTableStyles';
import { Order, isSelected } from '../../../utils/table';
import Checkbox from '../../../components/CustomCheckbox';
import CustomTableScroll from '../../../components/CustomTableScroll';
import { SmartLock } from '../../../types/Property';
import Status from '../../../components/LockStatus';

type Props = {
  order: Order;
  orderBy: string;
  rowsPerPage: number;
  onSelect: (event: React.SyntheticEvent, id: SmartLock['serial_number']) => void;
  onSelectAll: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeOrder: (order: Order, orderBy: string) => void;
  onRowClick: (id: SmartLock['serial_number']) => void;
  smartLocks: Array<SmartLock>;
  selected: Array<SmartLock['serial_number']>;
} & WithStyles<typeof styles>;

const SmartInventoryTable: React.FC<Props> = props => {
  const {
    selected,
    smartLocks,
    classes,
    order,
    orderBy,
    onSelect,
    onSelectAll,
    onChangeOrder,
    onRowClick,
  } = props;

  function handleRequestSort(
    event: React.SyntheticEvent,
    smartLock: string,
  ) {
    event.preventDefault();
    const isDesc = orderBy === smartLock && order === 'desc';
    onChangeOrder(isDesc ? 'asc' : 'desc', smartLock);
  }

  const tableContainer = useRef<HTMLDivElement>(null);

  return (
    <TableContainer ref={tableContainer} className={classes.tableContainer}>
      <CustomTableScroll getTableContainer={() => tableContainer} columns={18} />
      <MatTable className={classes.tableRoot}>
        <TableHead
          order={order}
          orderBy={orderBy}
          rowCount={smartLocks.length}
          numSelected={selected.length}
          onRequestSort={handleRequestSort}
          onSelectAllClick={onSelectAll}
        />
        <TableBody>
          {smartLocks.map((smartLock: SmartLock, index) => {
            const isItemSelected: boolean = isSelected(smartLock.serial_number, selected);
            const labelId: string = `enhanced-table-checkbox-${index}`;
            const formatedModificationDate = smartLock.modified_on
              ? `${convertDateWithTimezone(new Date(smartLock.modified_on))}
          ${convertDateToTimeWithTimezone(new Date(smartLock.modified_on))}` : '';
            return (
              <TableRow
                key={smartLock.serial_number}
                classes={{ root: classes.rowRoot }}
                hover
                tabIndex={-1}
                onClick={event => { event.stopPropagation(); onRowClick(smartLock.serial_number); }}
              >
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={isItemSelected}
                    inputProps={{ 'aria-labelledby': labelId }}
                    onClick={event => {
                      event.stopPropagation();
                      onSelect(event, smartLock.serial_number);
                    }}
                  />
                </TableCell>
                <TableCell align="center">{smartLock.serial_number}</TableCell>
                <TableCell align="center">{smartLock.device_id}</TableCell>
                <TableCell align="center">
                  <Status value={smartLock?.smartLockStatus ?? ''} />
                </TableCell>
                <TableCell align="center">{smartLock.client?.name ?? ''}</TableCell>
                <TableCell align="center">
                  {smartLock.property ? <Link className={classes.link} onClick={e => e.stopPropagation()} to={`/properties/${smartLock.property.property_id}`}>{ smartLock.property.property_id}</Link>
                    : '' }
                </TableCell>
                <TableCell align="center">{smartLock.created_on ? formatDate(smartLock.created_on) : ''}</TableCell>
                <TableCell align="center">{smartLock.created_by ?? ''}</TableCell>
                <TableCell align="center">
                  {' '}
                  { formatedModificationDate }
                </TableCell>
                <TableCell align="center">{smartLock.modified_by ?? ''}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </MatTable>
    </TableContainer>
  );
};

export default withStyles(styles)(SmartInventoryTable);
